const campaigns = [
  {
    from: '/campaigns/:id/participants',
    to: '/campaigns/:id/participants/shortlisted'
  },

  {
    from: '/campaigns/:campaignId/dashboard/:participantType',
    to: '/campaigns/:campaignId/participants/:participantType'
  },
  {
    from: '/campaigns/:id',
    to: '/campaigns/:id/participants/agreed'
  },
  {
    from: '/campaigns/:id/dashboard',
    to: '/campaigns/:id/participants/agreed'
  }
];

const collections = [
  {
    from: '/organizations/:orgId/lists',
    to: '/collections/creators'
  },
  {
    from: '/organizations/:orgId/lists/:listId',
    to: '/collections/creators/:listId?prev=lists&orgId=:orgId'
  },
  {
    from: '/organizations/:orgId/lists/:listId/proposal',
    to: '/collections/creators/:listId/proposal?page=1&sortBy=all&orgId=:orgId'
  },
  {
    from: '/organizations/:orgId/content-lists',
    to: '/collections/content?tab=smart'
  },
  {
    from: '/organizations/:orgId/content-lists/:listId',
    to: '/collections/content/:listId?orgId=:orgId'
  }
];

const discovery = [
  {
    from: '/content-creator/profiles',
    to: '/discovery/creators'
  },
  {
    from: '/organizations/:id/insights/content-discovery/view',
    to: '/discovery/content'
  },
  {
    from: '/campaigns/:id/choose-content-creators',
    to: '/discovery/creators'
  }
];

const insights = [
  {
    from: '/insights',
    to: '/insights/sov'
  },
  {
    from: '/organizations/:id/insights',
    to: '/insights/sov'
  },
  {
    from: '/organizations/:id/insights/sov/reports/view',
    to: '/insights/sov'
  },
  {
    from: '/organizations/:id/insights/sov/reports/:reportType/:reportId/edit',
    to: '/insights/sov/:reportType/:reportId'
  },
  {
    from: '/organizations/:id/insights/sov/:reportType/create',
    to: '/insights/sov'
  }
];

const organizations = [
  {
    from: '/campaigns',
    to: '/select-organization?next=campaigns'
  },
  {
    from: '/team',
    to: '/select-organization?next=team'
  }
];

const profiles = [
  {
    from: '/content-creator/profiles/create',
    to: '/'
  },
  {
    from: '/brand/profiles/create',
    to: '/'
  }
];

const signup = [
  {
    from: '/signup/influencer',
    to: '/signup/content-creator'
  },
  {
    from: '/signup/brand',
    to: '/signup'
  },
  {
    from: '/signup/agency',
    to: '/signup'
  }
];

const settings = [
  {
    from: '/organizations/:id/settings/billing',
    to: '/organizations/:id/settings/details'
  }
];

export default [
  ...campaigns,
  ...collections,
  ...discovery,
  ...insights,
  ...organizations,
  ...profiles,
  ...signup,
  ...settings
];
